// src/services/restApp.js
import feathers from '@feathersjs/feathers';
import rest from '@feathersjs/rest-client';
import superagent from 'superagent';
import auth from '@feathersjs/authentication-client';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3030';

const app = feathers()
  .configure(rest(baseURL).superagent(superagent))
  .configure(auth({ storage: window.localStorage }));

export default app;
